import { Component, OnInit } from "@angular/core";
import { ParametrizacionService } from "../parametrizacion/parametrizacion.service";
import { UsuarioParametrizado } from "../Modelos/UsuarioParametrizado";
import { EnlacePrincipalService } from "./enlace-principal-service.service";
import { IntermediarioEnlaceAcceso } from "../Modelos/IntermediarioEnlaceAcceso";
import { COMPOSITION_BUFFER_MODE } from "@angular/forms";
import { RequestIntermediarioEnlace } from "../Modelos/RequestIntermediarioEnlace";
import { IntermediarioEnlaceGeneral } from "../Modelos/IntermediarioEnlaceGeneral";

declare let mostrarToast: Function;

@Component({
  selector: "app-enlace-principal",
  templateUrl: "./enlace-principal.component.html",
  styleUrls: ["./enlace-principal.component.css"],
})
export class EnlacePrincipalComponent implements OnInit {
  usuarioABuscar: string;
  tipoIntermediarioSelect: number;
  codUsuarioSISESelect: string;
  IntermediariosEnlaceExisteAcceso: IntermediarioEnlaceAcceso[];
  isSelectDisabled: boolean;
  listaTipoIntermediarios: any[];
  listaCodUsuarios: string[];
  mensajeBotonGuardar: string;
  IntermediarioEnlaceCrearAcceso: IntermediarioEnlaceAcceso;
  objIntermediarioEnlaceGeneral: IntermediarioEnlaceGeneral;
  estadoCheck: Boolean;

  constructor(
    private parametrizacionService: ParametrizacionService,
    private enlacePrincipalService: EnlacePrincipalService
  ) {}

  ngOnInit() {
    this.estadoCheck = false;
    this.usuarioABuscar = "";
    this.isSelectDisabled = false;
    this.tipoIntermediarioSelect = undefined;
    this.codUsuarioSISESelect = undefined;
    this.mensajeBotonGuardar = "CREAR";
    this.IntermediariosEnlaceExisteAcceso = [];
  }

  async consultarUsuario() {
    this.IntermediariosEnlaceExisteAcceso = [];
    this.mensajeBotonGuardar = "CREAR";
    this.IntermediariosEnlaceExisteAcceso =
      await this.enlacePrincipalService.ConsultaIntermediarioExisteAcceso(
        parseInt(this.usuarioABuscar)
      );

    if (this.IntermediariosEnlaceExisteAcceso.length > 0) {
      const existeAccesoIntermediario = this.IntermediariosEnlaceExisteAcceso.some(
        (item) => item.inExisteAccesoIntermediario === 1
      );
      this.mensajeBotonGuardar = existeAccesoIntermediario ? "ACTUALIZAR" : "CREAR";
      this.listaTipoIntermediarios = this.IntermediariosEnlaceExisteAcceso.reduce(
        (result, item) => {
          const { cod_tipo_agente, txt_desc } = item;

          const existingItem = result.find(
            (obj) =>
              obj.cod_tipo_agente === cod_tipo_agente &&
              obj.txt_desc === txt_desc
          );

          if (!existingItem) {
            result.push({ cod_tipo_agente, txt_desc });
          }

          return result;
        },
        []
      );
      console.log("listaTipoIntermediarios: ", this.listaTipoIntermediarios);
      this.listaCodUsuarios = this.IntermediariosEnlaceExisteAcceso.reduce(
        (result, item) => {
          const { cod_usuario } = item;

          if (!result.includes(cod_usuario)) {
            result.push(cod_usuario);
          }

          return result;
        },
        []
      );
      console.log("listaCodUsuarios: ", this.listaCodUsuarios);
      if (this.listaTipoIntermediarios.length == 1) {
        this.tipoIntermediarioSelect = this.listaTipoIntermediarios[0].cod_tipo_agente;
      } else {
        this.codUsuarioSISESelect = undefined;
      }
      if (this.listaCodUsuarios.length == 1) {
        this.codUsuarioSISESelect = this.listaCodUsuarios[0];
      }
      if (this.listaTipoIntermediarios.length == 1 && this.listaCodUsuarios.length == 1) {
        this.IntermediarioEnlaceCrearAcceso = this.IntermediariosEnlaceExisteAcceso
          .filter(
            (item) =>
              item.cod_tipo_agente === this.tipoIntermediarioSelect &&
              item.cod_usuario === this.codUsuarioSISESelect
          )
          .find(() => true);

          let objIntermediarioEnlaceGeneral: IntermediarioEnlaceGeneral = await this.enlacePrincipalService.ConsultaIntermediarioEnlaceGeneral(
            this.IntermediarioEnlaceCrearAcceso.cod_agente
          );

          this.estadoCheck = (objIntermediarioEnlaceGeneral.estado === -1) ? true : false;
      }
      this.isSelectDisabled =
        this.listaTipoIntermediarios.length > 1 ? false : true;

      console.log(this.isSelectDisabled, "DisableComboIntermediario");
      console.log(this.listaTipoIntermediarios, "ListaTipoIntermediario");
      console.log(this.tipoIntermediarioSelect, "TipoIntermediarioSelect");
    } else {
      mostrarToast(
        "No se encuentran enlaces principales, intente de nuevo por favor..."
      );
    }

    console.log(
      this.IntermediariosEnlaceExisteAcceso,
      "IntermediarioExisteAcceso"
    );
  }

  soloNumerosSinEspacios(modelo: any, propiedad: string) {
    if (modelo[propiedad]) {
      modelo[propiedad] = modelo[propiedad].replace(/\D/g, "");
    }
  }

  async ConsultaIntermediarioExisteAcceso(usuarioABuscar) {}

  onTipoIntermediarioChange(event: any) {
    this.estadoCheck = false;
    this.listaCodUsuarios = [];
    console.log("Opción seleccionada:", this.tipoIntermediarioSelect);
    console.log(
      "Type of tipoIntermediarioSelect:",
      typeof this.tipoIntermediarioSelect
    );

    console.log("ChangeComboCodSISE", this.listaCodUsuarios);

    this.listaCodUsuarios = this.IntermediariosEnlaceExisteAcceso
      .filter(
        (item) => item.cod_tipo_agente === this.tipoIntermediarioSelect
      )
      .map((item) => item.cod_usuario);

    console.log("ChangeComboCodSISE2", this.listaCodUsuarios);
  }

  async oncodigoSISEChange(event: any) {
    this.estadoCheck = false;
    console.log("Opción seleccionada:", this.codUsuarioSISESelect);

    this.IntermediarioEnlaceCrearAcceso = this.IntermediariosEnlaceExisteAcceso
      .filter(
        (item) =>
          item.cod_tipo_agente === this.tipoIntermediarioSelect &&
          item.cod_usuario === this.codUsuarioSISESelect
      )
      .find(() => true);

    if (this.IntermediarioEnlaceCrearAcceso.inExisteAccesoIntermediario === 1) {
      let objIntermediarioEnlaceGeneral: IntermediarioEnlaceGeneral = await this.enlacePrincipalService.ConsultaIntermediarioEnlaceGeneral(
        this.IntermediarioEnlaceCrearAcceso.cod_agente
      );
      console.log("Intermediario_ACrearAcceso", objIntermediarioEnlaceGeneral);
      if (
        objIntermediarioEnlaceGeneral !== null &&
        objIntermediarioEnlaceGeneral.estado === -1
      ) {
        this.estadoCheck = true;
      } else if (
        objIntermediarioEnlaceGeneral !== null &&
        objIntermediarioEnlaceGeneral.estado === 0
      ) {
        this.estadoCheck = false;
      }
    }
  }

  async CrearActualizarIntermediarioEnlace() {
    if (this.mensajeBotonGuardar === "CREAR") {
      console.log(
        "requestCrearAcceoIntermediario",
        this.IntermediarioEnlaceCrearAcceso.cod_agente,
        this.IntermediarioEnlaceCrearAcceso.cod_tipo_agente,
        this.estadoCheck,
        this.IntermediarioEnlaceCrearAcceso.cod_usuario
      );

      let responseCrearIntermedario: boolean = await this.enlacePrincipalService.CrearAccesoIntermediarioEnlace(
        new RequestIntermediarioEnlace(
          this.IntermediarioEnlaceCrearAcceso.cod_agente,
          this.IntermediarioEnlaceCrearAcceso.cod_tipo_agente,
          this.estadoCheck ? -1 : 0,
          this.IntermediarioEnlaceCrearAcceso.cod_usuario
        )
      );
      console.log(
        "responseCrearAccesoIntermediario",
        responseCrearIntermedario
      );
      if (responseCrearIntermedario === true) {
        this.mensajeBotonGuardar = "ACTUALIZAR";
        mostrarToast("Usuario creado con éxito!");
      }  else if (responseCrearIntermedario === false) {
        this.mensajeBotonGuardar = "CREAR";
        mostrarToast("Ocurrió un problema en la creación del usuario");
      }
      this.IntermediariosEnlaceExisteAcceso =
        await this.enlacePrincipalService.ConsultaIntermediarioExisteAcceso(
          parseInt(this.usuarioABuscar)
        );
    } else if (this.mensajeBotonGuardar === "ACTUALIZAR") {
      console.log(
        "requestActualizacionEnlace",
        this.IntermediarioEnlaceCrearAcceso.cod_agente,
        this.IntermediarioEnlaceCrearAcceso.cod_tipo_agente,
        -1,
        this.IntermediarioEnlaceCrearAcceso.cod_usuario
      );
      let responseActualizarIntermedario: IntermediarioEnlaceGeneral = await this.enlacePrincipalService.ActualizarIntermediarioEnlace(
        new RequestIntermediarioEnlace(
          this.IntermediarioEnlaceCrearAcceso.cod_agente,
          this.IntermediarioEnlaceCrearAcceso.cod_tipo_agente,
          this.estadoCheck ? -1 : 0,
          this.IntermediarioEnlaceCrearAcceso.cod_usuario
        )
      );
      if (responseActualizarIntermedario !== null)
        mostrarToast("Se actualizó el usuario con éxito");
      else mostrarToast("Ocurrió un error en la actualización del usuario");
      this.estadoCheck =
        responseActualizarIntermedario.estado === -1 ? true : false;
      console.log("responseActualizacionEnlace", responseActualizarIntermedario);
      this.IntermediariosEnlaceExisteAcceso =
        await this.enlacePrincipalService.ConsultaIntermediarioExisteAcceso(
          parseInt(this.usuarioABuscar)
        );
    }
  }
}
